import React, {useState} from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Tab_01 from "../../images/services/et/Artificial-intelligence.webp";
import Tab_02 from "../../images/services/et/RPA.webp";
import Tab_03 from "../../images/services/et/Blockchain.webp";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Technologysec(props) {
    const [activeTab, setActiveTab] = useState(1);

    function displayTab(tabNumber) {
        setActiveTab(tabNumber);
    }

    return (
        <>
            <div className="tekgriping_section p-100">
                <Container className="h-100">
                    <Row className="h-100">
                        <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
                            <div className="example" data-text="Our Forte">
                                <h2>Our Forte</h2>
                            </div>
                            <p>Our deep understanding of emerging technologies enables us to provide you with customized
                                solutions that are tailored to your specific business needs and goals.</p>
                        </Col>
                        <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
                            <div className="tekgrip_flex">
                                <div className="tekgrip_title">
                                    <h5>74%
                                        <span>Usage</span></h5>
                                </div>
                                <div className="tekgrip_title">
                                    <h5>80%
                                        <span>Faster growth</span></h5>
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
                            <h3 onClick={() => {
                                displayTab(1)
                            }} className={`tabs ${activeTab === 1 ? 'active' : ''}`}>
                                <div className="tab_namee">Artificial intelligence</div>
                            </h3>

                            <h3 onClick={() => {
                                displayTab(2)
                            }} className={`tabs ${activeTab === 2 ? 'active' : ''}`}>
                                <div className="tab_namee">Robotic Process Automation</div>
                            </h3>

                            <h3 onClick={() => {
                                displayTab(3)
                            }} className={`tabs ${activeTab === 3 ? 'active' : ''}`}>
                                <div className="tab_namee">Blockchain</div>
                            </h3>

                        </Col>
                    </Row>
                </Container>
            </div>
            <div className="tekgrip_tabs_iamge tekrevol_dark_bg p-100">
                <Container className="h-100">
                    <Row className={activeTab === 1 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Artificial Intelligence</h2>
                                <p>Artificial intelligence is among the leading emerging technologies, helping the world
                                    become a better place in numerous ways. Utilizing the data available to bring
                                    practical ideas to life, create efficient AI/ML solutions, and enable better
                                    decision-making. TekRevol delivers world-class technology solutions to enable a
                                    better future.</p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image ">
                                <LazyLoadImage
                                    src={Tab_01}
                                    effect="blur" alt="Tab_01" className="img-fluid slide-top"
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className={activeTab === 2 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Robotic Process Automation</h2>
                                <p>Robotic Process Automation, or RPA, is an emerging domain where multiple technologies
                                    are used to build effective production and assembly lines to fast-track tedious
                                    processes. From image recognition to sorting to the assembly of complete vehicles –
                                    RPA is genuinely an advancement that the world needs.</p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image ">
                                <LazyLoadImage
                                    src={Tab_02}
                                    effect="blur" alt="Tab_02" className="img-fluid slide-top"
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className={activeTab === 3 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Blockchain</h2>
                                <p>Blockchain promises security, efficiency, and robustness, enabling organizations to
                                    build complete systems. TekRevol assists modern organizations in building great,
                                    cutting-edge, high-end solutions leveraging distributed functionality and utmost
                                    transparency. We help you build the applications for the future.</p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image ">
                                <LazyLoadImage
                                    src={Tab_03}
                                    effect="blur" alt="Tab_03" className="img-fluid slide-top"
                                />
                            </div>
                        </Col>
                    </Row>

                </Container>
            </div>
        </>
    );
}

export default Technologysec;